export default "__VITE_ASSET__BpMP144H__"